import Cookies from "browser-cookies";
import InitialState from "./initialState";
import {
  STATE_CULTURE,
  STATE_ACTIVE_PERSON_ID,
  THEME,
} from "../Actions/stateActions";

export const cookiesReducer = (keys, config) => (state, action) => {
  state = state || getInitialState(keys, config);

  switch (action.type) {
    case "@EE/EXPIRE_COOKIE": {
      const c = {};
      c[action.key] = null;

      return Object.assign({}, state, c);
    }
    case "@EE/SET_COOKIE": {
      const c = {};
      c[action.key] = action.value;

      return Object.assign({}, state, c);
    }
    default:
      return state;
  }
};

function getInitialState(keys, config) {
  const state = {};
  //Check if culture and theme is in cookie
  if (Cookies.get(STATE_CULTURE) == null) {
    Cookies.set(STATE_CULTURE, InitialState.culture, {
      samesite: "lax",
    });
  }
  if (Cookies.get(THEME) == null) {
    const defaultTheme = config.theme || InitialState.theme;
    Cookies.set(THEME, defaultTheme, { samesite: "lax" });
  }

  //Always clear activePersonId
  Cookies.erase(STATE_ACTIVE_PERSON_ID);

  for (var i = 0; i < keys.length; i++) {
    const key = keys[i];
    state[key] = Cookies.get(key);
  }

  return state;
}
